/**
 * SocialIcon — inline SVG icons for the platforms the Footer links to.
 * Kept as monochrome outlines so the icons pick up the surrounding
 * `color` / `text-*` utility, staying flexible for light or dark surfaces.
 * All artwork is drawn from scratch — no third-party brand asset files
 * are bundled or redistributed.
 */
import React from "react";

const paths = {
  facebook: (
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.14 8.44 9.94v-7.03H7.9V12.06h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34V22c4.78-.8 8.44-4.94 8.44-9.94z" />
  ),
  youtube: (
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4L15.8 12l-6.2 3.6z" />
  ),
  tiktok: (
    <path d="M19.75 6.3a5.6 5.6 0 0 1-3.28-1.06 5.6 5.6 0 0 1-2.14-3.24H10.9v13.2a3.02 3.02 0 1 1-2.14-2.9V8.6a6.3 6.3 0 1 0 5.58 6.26V9.35a8.94 8.94 0 0 0 5.4 1.81V6.31l-.01-.01z" />
  ),
  instagram: (
    <g>
      <path d="M12 2.16c3.2 0 3.58.02 4.85.07 1.17.05 1.8.25 2.22.42.56.22.96.48 1.38.9.42.42.68.82.9 1.38.17.42.37 1.05.42 2.22.05 1.27.07 1.65.07 4.85s-.02 3.58-.07 4.85c-.05 1.17-.25 1.8-.42 2.22-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.17-1.05.37-2.22.42-1.27.05-1.65.07-4.85.07s-3.58-.02-4.85-.07c-1.17-.05-1.8-.25-2.22-.42a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.17-.42-.37-1.05-.42-2.22-.05-1.27-.07-1.65-.07-4.85s.02-3.58.07-4.85c.05-1.17.25-1.8.42-2.22.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.17 1.05-.37 2.22-.42 1.27-.05 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.86 5.86 0 0 0-2.13 1.38A5.86 5.86 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.8.73 1.48 1.38 2.13.65.65 1.33 1.07 2.13 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.13-1.38 5.86 5.86 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.86 5.86 0 0 0-1.38-2.13A5.86 5.86 0 0 0 19.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0z" />
      <path d="M12 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16A4 4 0 1 1 12 8a4 4 0 0 1 0 8z" />
      <circle cx="18.4" cy="5.6" r="1.44" />
    </g>
  ),
  x: (
    <path d="M18.9 2.25h3.4l-7.43 8.5L23.5 21.75h-6.84l-5.36-7.01-6.13 7.01H1.77l7.94-9.09L1.15 2.25h7.02l4.85 6.4 5.88-6.4zm-1.2 17.5h1.88L6.4 4.15H4.4l13.3 15.6z" />
  ),
};

export default function SocialIcon({ name, className = "" }) {
  const P = paths[name];
  if (!P) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      {P}
    </svg>
  );
}
